import React, {Component} from 'react'
import {withStyles} from '@material-ui/core'
import style from './style'
import ImportantButton from '../../shared/components/ImportantButton';

/**
 * This component shows the Finalize button that is to be displayed in the Card Payment Feedback view.
 */
class EndButtons extends Component {

    render() {
        const {
            classes,
            successUrl
        } = this.props

        return (
            <div className={classes.main}>
                {successUrl ?
                    <ImportantButton component="a" href={successUrl} id="finishButton" {...this.props}>
                        Finalizar
                    </ImportantButton>
                : ""
                }
            </div>
        )
    }

}

export default withStyles(style)(EndButtons)
